
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import { warkLabel } from '@/models/wark';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';
import moment from 'moment';
import { getCurrentMonth } from '@/common/utils';
import { WriteGMVAmountModel } from '@/models/wark.model';
import { AuthEnum } from '@/services/permission.service';
import GMVAmountShopDrawer from '@/views/workbenches/subassembly/GMVAmountShopDrawer.vue';

@Component({
  components: {
    GMVAmountShopDrawer,
  },
})
export default class WriteGMVAmount extends Vue {
  typeChild: string | null = localStorage.getItem('typeChild');

  moment = moment;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  @Ref()
  gmvAmountShopDrawer!: GMVAmountShopDrawer;

  columns: any = [
    ...warkLabel.init('WriteGMVAmount').titleColumns,
  ];

  AuthEnum = AuthEnum;

  data: any = [];

  filterForm: any = {
    month: '',
    dept_id: undefined,
    group_id: undefined,
    agent_name: '',
  };

  dept_list: any = [];

  group_list: any = [];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
  };

  module: any = '';

  @Watch('$route')
  onRouteChange() {
    const { page, pageSize, module, month, dept_id, group_id, agent_name } = this.$route.query;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      module: module || '',
    };
    this.module = module;
    if (month) {
      params.month = month;
      this.filterForm.month = month;
    } else {
      params.month = getCurrentMonth();
      this.filterForm.month = getCurrentMonth();
    }
    if (dept_id) {
      params.dept_id = dept_id;
      this.filterForm.dept_id = +dept_id;
    }
    if (group_id) {
      params.group_id = group_id;
      this.filterForm.group_id = +group_id;
    }
    if (agent_name) {
      params.agent_name = agent_name;
      this.filterForm.agent_name = agent_name;
    }
    if (page) {
      this.pagination.current = +page;
    }
    if (pageSize) {
      this.pagination.pageSize = +pageSize;
    }
    this.getList(params);
  }

  refresh() {
  }


  async exportData() {
    // this.$message.info(JSON.stringify(val));
    const { month, dept_id, group_id, agent_name } = this.filterForm;
    const queryParams: any = {
      module: this.module,
      export: 1,
    };
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    await this.workbenchesService.getQuickEntranceExport(queryParams, '核销GMV金额数据');
  }

  back() {
    this.$router.push({ name: 'workbenches.index' });
  }
  changeColumns(val: string) {
    switch (val) {
      case 'director': // 总监
        this.columns = [
          ...warkLabel.init('WriteGMVAmount').department,
          ...warkLabel.init('WriteGMVAmount').groupLeader,
          ...warkLabel.init('WriteGMVAmount').titleColumns,
          ...warkLabel.init('WriteGMVAmount').actionRight,
        ];
        break;
      case 'assistantDirector': // 助理
        this.columns = [
          ...warkLabel.init('WriteGMVAmount').department,
          ...warkLabel.init('WriteGMVAmount').groupLeader,
          ...warkLabel.init('WriteGMVAmount').titleColumns,
          ...warkLabel.init('WriteGMVAmount').actionRight,
        ];
        break;
      case 'kaTeamLeader': // 部长
        this.columns = [
          ...warkLabel.init('WriteGMVAmount').department,
          ...warkLabel.init('WriteGMVAmount').groupLeader,
          ...warkLabel.init('WriteGMVAmount').titleColumns,
          ...warkLabel.init('WriteGMVAmount').actionRight,
        ];
        break;
      case 'ordinaryTeamMinister': // 部长
        this.columns = [
          ...warkLabel.init('WriteGMVAmount').department,
          ...warkLabel.init('WriteGMVAmount').groupLeader,
          ...warkLabel.init('WriteGMVAmount').titleColumns,
          ...warkLabel.init('WriteGMVAmount').actionRight,
        ];
        break;
      case 'kaTeamMinister': // 组长
        this.columns = [
          ...warkLabel.init('WriteGMVAmount').supplementGroupLeader,
          ...warkLabel.init('WriteGMVAmount').groupLeader,
          ...warkLabel.init('WriteGMVAmount').titleColumns,
          ...warkLabel.init('WriteGMVAmount').actionRight,
        ];
        break;
      case 'ordinaryTeamLeader': // 组长
        this.columns = [
          ...warkLabel.init('WriteGMVAmount').supplementGroupLeader,
          ...warkLabel.init('WriteGMVAmount').groupLeader,
          ...warkLabel.init('WriteGMVAmount').titleColumns,
          ...warkLabel.init('WriteGMVAmount').actionRight,
        ];
        break;
      default: // 普通
        this.columns = [
          ...warkLabel.init('WriteGMVAmount').supplementTitleColumns,
          ...warkLabel.init('WriteGMVAmount').titleColumns,
          ...warkLabel.init('WriteGMVAmount').action,
        ];
        break;
    }
    const obj: any = {
      dept_name: 'dept_id',
      dept_manager: 'dept_id',
      dept_gmv_target: 'dept_id',
      dept_gmv: 'dept_id',
      dept_gmv_ratio: 'dept_id',
      group_manager: 'group_id',
      group_gmv_target: 'group_id',
      group_gmv: 'group_id',
      group_gmv_ratio: 'group_id',
      group_name: 'group_id',
    };
    this.columns.forEach((res: any) => {
      if (Object.prototype.hasOwnProperty.call(obj, res.dataIndex)) {
        res.customRender = (text: any, row: any, index: any) => {
          return this.customRender(text, row, index, obj[res.dataIndex]);
        };
      }
    });
  }
  customRender(text: any, row: any, index: any, column: any) {
    const prevRow: any = this.data[index - 1];
    if (prevRow && prevRow[column] === row[column]) {
      return {
        children: text,
        attrs: {
          rowSpan: 0,
        },
      };
    }
    let rowSpan = 1;
    const _i: number = index;
    for (let i = _i + 1; i < this.data.length; i++) {
      const currentRow: any = this.data[i];
      if (currentRow[column] === row[column]) {
        rowSpan++;
      } else {
        break;
      }
    }
    return {
      children: text,
      attrs: {
        rowSpan,
      },
    };
  }

  async getList(val: any) {
    const res = await this.workbenchesService.getQuickEntrance(val, this.$el);
    this.data = WriteGMVAmountModel.from(res.list);
    this.pagination.current = res.page;
    this.pagination.total = res.total;
  }


  handleEdit(val: any) {
    // this.$message.info(JSON.stringify(val));
    const { month, dept_id, group_id, agent_name } = this.filterForm;
    const old_params: any = {
      module: this.module,
    };
    if (month) {
      old_params.month = month;
    }
    if (dept_id) {
      old_params.dept_id = dept_id;
    }
    if (group_id) {
      old_params.group_id = group_id;
    }
    if (agent_name) {
      old_params.agent_name = agent_name;
    }
    this.$router.push({
      name: 'workbenches.GMVWriteOrders',
      params: { id: val.user_id },
      query: {
        old_params: (JSON.stringify(old_params)),
        month,
      },
    });
  }

  handleShopDrawer(val: any) {
    this.gmvAmountShopDrawer.init(val);
  }

  onChange(current: number, pageSize: number) {
    this.pagination.current = current;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  search() {
    this.getQueryParams();
  }

  reset() {
    this.filterForm = {
      month: '',
      dept_id: undefined,
      group_id: undefined,
      agent_name: '',
    };
    this.pagination.current = 1;
    this.getQueryParams();
  }

  getQueryParams() {
    const { current, pageSize } = this.pagination;
    const { month, dept_id, group_id, agent_name } = this.filterForm;
    const queryParams: any = {
      page: current,
      pageSize,
      module: this.module,
    };

    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }

    queryParams.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query: queryParams,
    });
  }


  async getDeptInfo() {
    const res = await this.workbenchesService.getDeptInfo();
    this.dept_list = res;
    const { dept_id } = this.$route.query;
    if (!dept_id) return;
    const deptId = Number(dept_id);
    this.group_list = this.dept_list.find((item: any) => item.dept.id === deptId).group;
  }

  selectOption(val: any) {
    this.group_list = this.dept_list.find((res: any) => res.dept.id === val).group;
    this.filterForm.group_id = undefined;
  }

  changeMonth(val: any) {
    const year = val._d.getFullYear(); // 获取当前年份，例如：2021
    let month: any = Number(val._d.getMonth()) + 1; // 获取当前月份，注意需要加1，例如：9
    if (month < 10) {
      month = `0${month}`;
    }
    const _d = `${year}-${month}`;
    this.filterForm.month = _d;
  }

  mounted() {
    this.changeColumns(this.typeChild!);
    this.onRouteChange();
    this.getDeptInfo();
  }
}
